/**
 * Custom select component (c-select)
 *
 * Handles two modes based on markup:
 * - Link mode (<a> options): clicking navigates to URL
 * - State mode (<div> options): clicking toggles active state
 */
const initSelect = () => {

	const selects = document.querySelectorAll( '.js-c-select' );

	selects.forEach( ( select ) => {

		const trigger = select.querySelector( '.js-c-select-trigger' );
		const label = select.querySelector( '.js-c-select-label' );
		const options = select.querySelectorAll( '.js-c-select-option' );

		if ( ! trigger || ! label || ! options.length ) {

			return;

		}


		/**
		 * Closes the dropdown by removing the is-open class.
		 *
		 * @return {void}
		 */
		const close = () => select.classList.remove( 'is-open' );

		/**
		 * Generates a list of options as an array.
		 *
		 * @return {HTMLElement[]} Array of option elements.
		 */
		const getOptionsList = () => Array.from( options );

		/**
		 * Focus an option by index.
		 *
		 * @param {number} index Index of the option to focus.
		 * @return {void}
		 */
		const focusOption = ( index ) => getOptionsList()[ index ].focus();

		trigger.addEventListener( 'click', () => {

			const isOpening = ! select.classList.contains( 'is-open' );
			select.classList.toggle( 'is-open' );

			if ( isOpening ) {

				const list = getOptionsList();
				const selectedIndex = list.findIndex( ( o ) => o.classList.contains( 'is-selected' ) );
				focusOption( selectedIndex !== -1 ? selectedIndex : 0 );

			}

		} );

		document.addEventListener( 'click', ( e ) => {

			if ( ! select.contains( e.target ) ) {

				close();

			}

		} );

		select.addEventListener( 'focusout', ( e ) => {

			if ( ! select.contains( e.relatedTarget ) ) {

				close();

			}

		} );

		select.addEventListener( 'keydown', ( e ) => {

			const isOpen = select.classList.contains( 'is-open' );

			if ( e.key === 'Escape' && isOpen ) {

				close();
				trigger.focus();
				return;

			}

			if ( ( e.key === 'ArrowDown' || e.key === 'ArrowUp' ) && isOpen ) {

				e.preventDefault();

				const list = getOptionsList();
				const currentIndex = list.indexOf( select.ownerDocument.activeElement );
				const total = list.length;
				let nextIndex;

				if ( e.key === 'ArrowDown' ) {

					nextIndex = currentIndex === -1 ? 0 : ( currentIndex + 1 ) % total;

				} else {

					nextIndex = currentIndex === -1 ? total - 1 : ( currentIndex - 1 + total ) % total;

				}

				focusOption( nextIndex );

			}

		} );

		options.forEach( ( option ) => {

			const isLink = option.tagName === 'A';

			option.addEventListener( 'click', ( e ) => {

				if ( ! isLink ) {

					e.preventDefault();

				}

				const value = option.dataset.value;
				const text = option.querySelector( 'span' ).textContent;

				options.forEach( ( opt ) => opt.classList.remove( 'is-selected' ) );

				if ( value ) {

					option.classList.add( 'is-selected' );

				}

				label.textContent = text;

				close();

			} );

		} );

	} );

};

document.addEventListener( 'DOMContentLoaded', initSelect );
